import axios from 'axios';
import { handleLogout } from '../../utils';

// Create an Axios instance
const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL.trim(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
http.interceptors.request.use(
  (config) => {
    // Add token to headers if available
    const userData = localStorage.getItem('data');
    const token = userData && JSON.parse(userData).tokens.access.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Response error:', error);
    if (error.response) {
      // Handle specific HTTP errors
      const { status } = error.response;
      console.log(error.config.url)
      const excemptedURL = ["/v1/auth/login"];
      if (status === 401 && excemptedURL.indexOf(error.config.url) == -1) {
        console.warn('Unauthorized. Redirecting to login.');
        handleLogout();
      } else if (status === 403) {
        console.warn('Forbidden. Insufficient permissions.');
      } else if (status >= 500) {
        console.error('Server error. Please try again later.');
      }
    }
    return Promise.reject(error);
  }
);

export default http;
